import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators, FormControl } from '@angular/forms';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Image } from '../../../../../images/images'
import { JoinTypeService } from 'src/app/shared/API-Service/services/join-type.service';


@Component({
  selector: 'app-insert-join-type',
  templateUrl: './insert-join-type.component.html',
  styleUrls: ['./insert-join-type.component.css']
})
export class InsertJoinTypeComponent implements OnInit {
  recordtoupdate: any;
  cities:any;
  jointype:any;
  jointypeForm:FormGroup;
  jointypedataForm:FormData;
  update:boolean = false;
  button:boolean = false;
  Image: File;
imageLogo: string;
img : string = Image;
  constructor(private _JoinTypeService:JoinTypeService,private _Router:Router,private _FormBuilder:FormBuilder) {
    this.imageLogo="../../../../../assets/images/upload.png"

   }

  ngOnInit(): void {
    this.initiate();
    this.checkEdit();
  }

  initiate(){
    this.jointypeForm = this._FormBuilder.group({
      title: ['', Validators.required],
      order: ['', Validators.required],
     jointypeimage:['', Validators.required]
    });
  }
  insertappenddata(){
    this.jointypedataForm = new FormData();
    this.jointypedataForm.append("Title", this.jointypeForm.value.title);
    this.jointypedataForm.append("Order", this.jointypeForm.value.order);
    this.jointypedataForm.append("JoinTypeImage", this.Image);
  }
  updateappenddata(){
    this.jointypedataForm = new FormData();
    this.jointypedataForm.append("Title", this.jointypeForm.value.title);
    this.jointypedataForm.append("Order", this.jointypeForm.value.order);
    this.jointypedataForm.append("JoinTypeImage", this.Image);
    this.jointypedataForm.append("Id", this.recordtoupdate.id);
  }

  checkEdit() {
    this._JoinTypeService.Data.subscribe((res) => {
      if (res != null) {
        this.jointypeForm = this._FormBuilder.group({
          title: [res.title, Validators.required],
          order: [res.order, Validators.required],
          jointypeimage:[res.image, Validators.required],
          
        });
        this.imageLogo = this.img + res.image;
        this.update = true;
        this.recordtoupdate = res ;
        console.log(this.recordtoupdate);
      } else {
        console.log(`not found on data`);
      }
     
    });
  }
       // imgFile
       getLogoUrl(event: any) {
        const reader = new FileReader();
        if (event.target.files && event.target.files.length) {
          const [file] = event.target.files;
          this.Image = event.target.files[0];
          reader.readAsDataURL(file);
          reader.onload = () => {
            this.imageLogo = reader.result as string;
            // this.logoForm?.append("image", this.Image);
          };
        }
      }
  get fc() {
    return this.jointypeForm.controls;
  }

  onSubmit(){
    this.button = true;
  if(this.update == false && this.jointypeForm.status == "VALID"){
    this.insertappenddata();
    this._JoinTypeService.CreateJoinType(this.jointypedataForm).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم الحفظ بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.jointypeForm.reset();
      this._Router.navigate(['/content/admin/ViewJoinType']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
      this.button = false ;
    }, () => {
      console.log('completed ');
    })
  } else if(this.jointypeForm.status == "VALID"){
    this.updateappenddata();
    this._JoinTypeService.UpdateJoinType(this.jointypedataForm).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم التعديل بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.jointypeForm.reset();
      this._Router.navigate(['/content/admin/ViewJoinType']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
    }, () => {
      console.log('completed ');
    })
  }else {
    Swal.fire({
      icon: 'error',
      title: 'خطأ',
      text:"بالرجاء التأكد من ملئ جميع الحقول"   
    })
    this.jointypeForm.markAllAsTouched();
    this.button = false;
  }
  }

  ngOnDestroy(){
    this._JoinTypeService.Data.next(null);
    }

}
